import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001; /* acima do modal de progresso (que costuma ser 9999/10000) */
  backdrop-filter: blur(2px);
`;

export const TerminalWindow = styled.div`
  background: #0d1117;
  border: 1px solid #30363d;
  border-radius: 10px;
  width: min(900px, 92vw);
  height: min(600px, 80vh);
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
  animation: ${fadeIn} 0.18s ease-out;
  overflow: hidden;
  font-family: 'Menlo', 'Consolas', 'Courier New', monospace;
`;

export const TerminalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #161b22;
  border-bottom: 1px solid #30363d;
  user-select: none;

  .left {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #c9d1d9;
    font-size: 0.85rem;
  }
  .title { font-weight: 600; }
  .subtitle { opacity: 0.7; font-weight: 400; }
  .counter {
    margin-left: 8px;
    padding: 2px 8px;
    background: rgba(110, 118, 129, 0.2);
    border-radius: 10px;
    font-size: 0.7rem;
    opacity: 0.75;
  }
  .right {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;

export const StatusDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(p) => (p.$connected ? "#10b981" : "#ef4444")};
  box-shadow: 0 0 8px ${(p) => (p.$connected ? "#10b98155" : "#ef444455")};
`;

export const IconBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: transparent;
  border: 1px solid transparent;
  color: #c9d1d9;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: rgba(110, 118, 129, 0.2);
    border-color: #30363d;
  }
  svg { font-size: 0.95rem; }
`;

export const TerminalBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 10px 14px;
  background: #0d1117;
  color: #c9d1d9;
  font-size: 0.78rem;
  line-height: 1.5;

  &::-webkit-scrollbar { width: 8px; height: 8px; }
  &::-webkit-scrollbar-track { background: #0d1117; }
  &::-webkit-scrollbar-thumb { background: #30363d; border-radius: 4px; }
  &::-webkit-scrollbar-thumb:hover { background: #484f58; }

  .loading, .empty {
    text-align: center;
    padding: 20px;
    color: #8b949e;
    font-style: italic;
  }
  .error-line {
    color: #f85149;
    padding: 8px;
    background: rgba(248, 81, 73, 0.1);
    border-radius: 4px;
    margin-bottom: 8px;
  }
`;

export const LineRow = styled.div`
  white-space: pre-wrap;
  word-break: break-word;
  padding: 1px 0;
  color: ${(p) => {
    if (p.$level === "error") return "#f85149";
    if (p.$level === "warn") return "#d29922";
    return "#c9d1d9";
  }};
`;

export const TerminalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 6px 14px;
  background: #161b22;
  border-top: 1px solid #30363d;
  color: #8b949e;
  font-size: 0.7rem;

  code {
    background: rgba(110, 118, 129, 0.2);
    padding: 1px 6px;
    border-radius: 3px;
    color: #c9d1d9;
  }
`;
